import { ICalendarSettings, defaultCalendarSettings, CalendarDeviceMode, CalendarViewMode } from '../../classes/calendar';
import { ActionType, ICalendarStateAction } from '../../classes/calendar-actions';

import * as moment from 'moment';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function calendarSettingsReducer(state: ICalendarSettings = defaultCalendarSettings, action: ICalendarStateAction) {
    switch (action.type) {
        case ActionType.UpdateSettings: {
            return { ...state, ...action.value } as ICalendarSettings;
        }
        case ActionType.SetToDesktop: {
            return { ...state, calendarDeviceMode: CalendarDeviceMode.DESKTOP } as ICalendarSettings;
        }
        case ActionType.SetToMobile: {
            return { ...state, calendarDeviceMode: CalendarDeviceMode.MOBILE, calendarViewMode: CalendarViewMode.LIST } as ICalendarSettings;
        }
        case ActionType.SetToGrid: {
            return { ...state, calendarViewMode: CalendarViewMode.GRID } as ICalendarSettings;
        }
        case ActionType.SetToList: {
            return { ...state, calendarViewMode: CalendarViewMode.LIST } as ICalendarSettings;
        }
        default:
            return state;
    }
}
